var AdyenPaymentType = /* @__PURE__ */ ((AdyenPaymentType2) => {
  AdyenPaymentType2["Card"] = "card";
  AdyenPaymentType2["Bancontact"] = "bcmc";
  AdyenPaymentType2["BancontactMobile"] = "bancontactMobile";
  AdyenPaymentType2["Sepa"] = "sepadirectdebit";
  AdyenPaymentType2["Swish"] = "swish";
  AdyenPaymentType2["GooglePay"] = "googlepay";
  return AdyenPaymentType2;
})(AdyenPaymentType || {});
export {
  AdyenPaymentType
};
//# sourceMappingURL=payment-type.js.map
